import { getGroupPermissionFactory, PermissionEnum } from '../../../common';
import { getCustomerManagementModuleName } from './customer-management.permissions';

export class CustomerProfilesPermissions {
  static GroupName = `${getCustomerManagementModuleName()}.CustomerProfiles`;

  static getPermissions = getGroupPermissionFactory(CustomerProfilesPermissions.GroupName);

  static Permissions = {
    Create: CustomerProfilesPermissions.getPermissions(PermissionEnum.CREATE),
    Update: CustomerProfilesPermissions.getPermissions(PermissionEnum.UPDATE),
    Read: CustomerProfilesPermissions.getPermissions(PermissionEnum.READ),
    ReadAll: CustomerProfilesPermissions.getPermissions(PermissionEnum.READ_ALL),
    ReadByPhoneNumber: CustomerProfilesPermissions.getPermissions('ReadByPhoneNumber')
  };
}
